import { useEffect, useState } from 'react'
import CustomDataTable from './DataTable'
import CustomPaginator from '../paginator/CustomPaginator'

const ParentDataTable = ({ value, columns, rows, filters, loading, globalFilterFields, archiveKey, onFilter, pagination=true }) => {
  const [first, setFirst] = useState(0)

  const onPageChange = (event) => {
    setFirst(event.first)
  }

  useEffect(() => {
    setFirst(0)
  }, [rows,filters])

  return (
    <>
      <CustomDataTable
        value={value}
        columns={columns}
        paginator={true}
        rows={rows}
        first={first}
        filters={filters}
        loading={loading}
        globalFilterFields={globalFilterFields}
        onPageChange={onPageChange}
        archiveKey={archiveKey}
        onFilter={onFilter}
      />
      {pagination && <CustomPaginator totalRows={value?.length} rowsCount={rows} first={first} onPageChange={onPageChange} />}
    </>
  )
}

export default ParentDataTable
